module.exports = __webpack_public_path__ + "static/media/logo.f7f2047e.png";